module.exports = __webpack_public_path__ + "static/img/lsqfw.7f26894.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/lsqfw.png
// module id = gbR3
// module chunks = 0